import { apiClient } from '@/lib/api-client';
import type { WhatsAppConfigMasked, UpsertWhatsAppConfigInput, TestWhatsAppResult } from '@bbpos/types';

export const whatsappService = {
  getConfig() {
    return apiClient<WhatsAppConfigMasked>('/integrations/whatsapp/config');
  },

  upsertConfig(input: UpsertWhatsAppConfigInput) {
    return apiClient<WhatsAppConfigMasked>('/integrations/whatsapp/config', {
      method: 'PUT',
      body: input,
    });
  },

  testConfig() {
    return apiClient<TestWhatsAppResult>('/integrations/whatsapp/config/test', { method: 'POST' });
  },

  deactivateConfig() {
    return apiClient<{ deactivated: boolean }>('/integrations/whatsapp/config', {
      method: 'DELETE',
    });
  },
};
